module.exports = __webpack_public_path__ + "static/media/icon-shop-background.0e3af51e.png";